import {ContactUseCase} from "@app/core/contact/application/contact.usecase";
import {Contact} from "@app/core/contact/domain/contact";
import {Injectable} from "@angular/core";
import {PopupNotifier} from "@app/presentation/components/errors/popup.notifier";
import {BehaviorSubject, Observable, Subscriber} from "rxjs";
import {GetUserUseCase} from "@app/core/user/application/get-user.usecase";
import {User} from "@app/core/user/domain/entities/user";
import {onIsLoadingChanges} from "@app/presentation/rxjs-utils/operators/on-is-loading-changes";
import {take} from "rxjs/operators";

interface PhonePrefixOption {
    value: string;
    label: string;
}

const PHONE_PREFIX_OPTIONS: PhonePrefixOption[] = [
    {value: "+34", label: "+34 (ES)"},
    {value: "+351", label: "+351 (PT)"},
]

@Injectable({
    providedIn: 'root',
})

export class ContactViewModel {
    public notifier = new PopupNotifier()
    private succeedEmitter!: Subscriber<boolean>
    private userEmitter!: Subscriber<User>
    public messageSendObservable: Observable<boolean> = new Observable<boolean>(emitter => this.succeedEmitter = emitter)
    public userObservable: Observable<User> = new Observable<User>(emitter => this.userEmitter = emitter)

    public phonePrefixesOptions$: Observable<PhonePrefixOption[]> = new BehaviorSubject(PHONE_PREFIX_OPTIONS)

    private isContactLoadingSubject = new BehaviorSubject(false)
    readonly isContactLoading$ = this.isContactLoadingSubject.asObservable()

    constructor(private contactUseCase: ContactUseCase, private getUserUseCase: GetUserUseCase) { }

    public contact(contact: Contact) {
        if (this.isContactLoadingSubject.getValue()) {
            return
        }
        this.isContactLoadingSubject.next(true)
        this.contactUseCase.execute(contact)
            .pipe(
                take(1),
                onIsLoadingChanges(isLoading => this.isContactLoadingSubject.next(isLoading))
            )
            .subscribe({
                next: () => {
                    this.succeedEmitter.next(true)
                },
                error: error => {
                    this.notifier.notifyError(error)
                }
            });
    }

    public getUser() {
        const user = this.getUserUseCase.execute();
        if (user) {
            this.userEmitter.next(user)
        }
    }

}
